import { getPerspectiveId } from "@app/lib/perspective";
import NaturePivotPage, {
  naturePivotQuery,
} from "@app/pages/expense-natures/nature-pivot-page";
import type { naturePivotPage_Query } from "@app/queries/naturePivotPage_Query.graphql";
import { environment } from "@app/relay/relay-environment";
import { pageHead } from "@app/lib/page-title";
import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { loadQuery } from "react-relay";

export const Route = createFileRoute("/_authed/expense-natures")({
  loader: () =>
    loadQuery<naturePivotPage_Query>(
      environment,
      naturePivotQuery,
      { perspectiveId: getPerspectiveId() ?? undefined },
      { fetchPolicy: "network-only" }
    ),
  head: () => pageHead("Expense nature"),
  component: ExpenseNaturesRoute,
});

function ExpenseNaturesRoute() {
  const queryRef = Route.useLoaderData();

  return (
    <ErrorBoundary
      fallback={<div className="p-6 text-red-500">Error loading the nature pivot</div>}
    >
      <Suspense fallback={<div className="p-6 text-gray-500">Loading spend by nature...</div>}>
        <NaturePivotPage queryRef={queryRef} />
      </Suspense>
    </ErrorBoundary>
  );
}
